import React from 'react'

//css
import '../../../App.css'

//COMPONENTS
import ItemListContainer from '../../ItemListContainer/ItemListContainer';


function Home() {
  return (
    <>
      <ItemListContainer />
    </>
  )
}

export default Home